var _rect, _image, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _tspan, _tspan2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCounselingBenchmarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 175 179",
    enableBackground: "new 0 0 175 179",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    fill: "#FFFFFF",
    stroke: "#D1D1D1",
    strokeMiterlimit: 10,
    width: 175,
    height: 179,
    id: "rect3790"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 96,
    height: 125,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAAB9CAYAAABd0GZ9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ bWFnZVJlYWR5ccllPAAAA3NpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdp bj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6 eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1 NDkxMSwgMjAxMy8xMC8yOS0xMTo0NzoxNiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJo dHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlw dGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEu MC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVz b3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1N Ok9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowYmU1OWNhZC0wNWE0LTQ0OWUtOTE5NS00OTdl M2JhMzI2NGQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QTg0RjRFODQ3ODNGMTFFNDg2RDND MDYwNjQ1RjI2NzQiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QTg0RjRFODM3ODNGMTFFNDg2 RDNDMDYwNjQ1RjI2NzQiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNp bnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NGY1 N2MxYTktYTE1Zi00NTUyLWE5ZjQtOWNiYmQ2MGNkZjYwIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAu ZGlkOjBiZTU5Y2FkLTA1YTQtNDQ5ZS05MTk1LTQ5N2UzYmEzMjY0ZCIvPiA8L3JkZjpEZXNjcmlw dGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PmyO5bsAAAGm SURBVHja7N27bQJBFIVhBrkZUhL6cEwNVGAiOqAERIyFXIUTKrJ4ZZuxXs2Lme+PHCzJ/HvuPayR NpzOP7cZijF3BGX5GPwdHEdWbhJgBIEAAggAAQSggu8Bo7srRhEkwAgCAQSAAAJAAAEggAAQUBn/ fRbk/8YSQAAIIAAEEAACCEDmL2J48Hm8jLrutF4SkJBXvxAJKRJQy89SmnkkYgcQYAl3Gf0UC1UL KrxQjSA7AKlHkBoqAUYQ1ND66qQaWrhOGkF2ANRQCQABGfhaXKNc01QNrVGCBGS+mwnQgt6zBaW8 wyVAC2pvlu9W+yjXNNeCphzw86C2v5uX13z/HSYdsBHU2BJuklh3c9cJiDmX1dCJu6jGA7YDCEA3 NVQCQAAB6LeGSgCSJ6B2QsbPRUlhGLxFScXMi3fI2AEgQA1tF+8PMIIQfQSpqhJAAAhQQ6GGGkFQ QyUABBAANVQNhRGkhkICCIAWpAXBCNKCIAEEgAA1VA2VACMIaqgEgAACoIaqoSBADYUEEAACCAAB BBDgCAggAAQQgDIMnwV51CwB/XEXYAD0F0HTR7KGzwAAAABJRU5ErkJggg==",
    transform: "matrix(1 0 0 1 39.4998 41.5618)",
    id: "image3828"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3830"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g3832"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g3834"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g3836"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g3838"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g3840"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g3842"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g3844"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g3846"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g3848"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g3850"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g3852"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "g3854"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "g3856"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "g3858"
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "13.33333302px",
      lineHeight: 1.25,
      fontFamily: "Corbel",
      InkscapeFontSpecification: "'Corbel Bold'",
      textAlign: "center",
      letterSpacing: 0,
      wordSpacing: 0,
      textAnchor: "middle",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none"
    },
    x: 87.57132,
    y: 15.368006,
    id: "text3885"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan3883",
    x: 87.57132,
    y: 15.368006
  }, "A-G Counseling")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 87.57132,
    y: 32.034672,
    id: "tspan3887"
  }, "Benchmarks"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounselingBenchmarks);
export default __webpack_public_path__ + "static/media/counselingBenchmarks.17e9779e6a3ae0a2c9a0888d97a615ed.svg";
export { ForwardRef as ReactComponent };